import { Link } from 'react-router-dom';

type Lp = (path: string) => string;

export function TermsBodyEn({ lp }: { lp: Lp }) {
  return (
    <article className="policy-section">
<h1>Terms of Use</h1>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Acceptance of Terms</h2>
        <p>
          By accessing, browsing, or using the Lotto Number Generator website at lotto-number-generator.com
          (the &quot;Site&quot;), you acknowledge that you have read, understood, and agree to be bound by these Terms
          of Use (&quot;Terms&quot;). If you do not agree to these Terms, you must not access or use the Site. These
          Terms apply to all visitors, users, and anyone else who accesses the Site, whether through a web browser,
          mobile device, or any other means. We reserve the right to update or modify these Terms at any time, and your
          continued use of the Site following any such changes constitutes your acceptance of the revised Terms. It is
          your responsibility to review these Terms periodically.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Description of Service</h2>
        <p>
          The Lotto Number Generator is a free online tool that generates random number combinations for popular lottery
          games, including Powerball, Mega Millions, and Korean Lotto 6/45. The generator uses pseudo-random number generation to produce sets of numbers within the
          official ranges for each supported game. Every generated set is automatically compared against a database of
          thousands of real historical jackpot-winning draws for entertainment purposes.
        </p>
        <p>
          All features of the Site are free to use, including random number generation, historical jackpot matching,
          and access to draw history. We do not sell any products, subscriptions, or paid features.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Personal, Non-Commercial Use</h2>
        <p>
          You may use this lotto number generator for <strong>personal, non-commercial entertainment</strong> only. We
          are not affiliated with any lottery operator, government agency, or official lottery organization. Official
          lottery tickets are sold only by authorized retailers in your jurisdiction. You may not use the Site or its
          outputs for any commercial purpose, including but not limited to reselling generated numbers, creating
          derivative products, or incorporating our tools into your own commercial services without prior written
          permission.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Not Gambling, Wagering, or Betting</h2>
        <p>
          This website does <strong>not</strong> accept stakes, run games of chance for a prize, pay winnings, or
          operate as a casino, sportsbook, or betting platform of any kind. We provide{' '}
          free <strong>software tools</strong> for random number generation.
          Using our tools does not place a bet, purchase a lottery ticket, or enter you into any drawing or sweepstakes.
          The numbers generated by the Site are produced by a software algorithm and carry no guarantee of winning any
          prize in any lottery or game of chance. We do not facilitate, promote, or encourage gambling activity. The
          Site is a utility for entertainment purposes, similar to a coin flip or dice roll simulator.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>No Financial or Lottery Advice</h2>
        <p>
          Nothing on this Site constitutes investment, tax, legal, or financial advice. Nothing we offer improves your
          mathematical odds of winning any lottery. Lottery drawings are independent random events, and no pattern,
          strategy, or tool can predict or influence future outcomes. Past winning numbers have no bearing on future
          results. Play only for entertainment and only where participation is lawful for you. If you or someone you
          know has a gambling problem, please contact the National Council on Problem Gambling at 1-800-522-4700.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Intellectual Property</h2>
        <p>
          All content on the Site, including but not limited to text, graphics, logos, icons, images, software code,
          user interface design, and the selection and arrangement thereof, is the property of Lotto Number Generator or
          its licensors and is protected by United States and international copyright, trademark, and other intellectual
          property laws. You may not copy, reproduce, distribute, transmit, display, perform, publish, license, create
          derivative works from, transfer, or sell any content, information, software, or services obtained from the
          Site without our prior written consent. You are granted a limited, non-exclusive, non-transferable license to
          access and use the Site for personal, non-commercial purposes only, subject to these Terms.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Lawful and Honest Use</h2>
        <p>
          You must not use this Site for fraud, deception, harassment, infringement of others&apos; rights, or any
          unlawful purpose. Do not misrepresent what the tool does or imply guaranteed outcomes. You agree not to
          interfere with or disrupt the operation of the Site, introduce malicious code, attempt to gain unauthorized
          access to our systems, or use automated tools to scrape or harvest content from the Site without permission.
          Any violation of these provisions may result in termination of your access to the Site and may expose you to
          civil and criminal liability.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>No Warranty</h2>
        <p>
          We provide the Site and all of its features on an &quot;as is&quot; and &quot;as available&quot; basis without
          warranties of any kind, whether express, implied, or statutory. We specifically disclaim all implied
          warranties of merchantability, fitness for a particular purpose, title, and non-infringement. The numbers
          generated are random and we make no representations or guarantees regarding the accuracy, reliability, or
          completeness of any information, content, or materials on the Site. We do not warrant that the Site will be
          uninterrupted, error-free, or free of viruses or other harmful components. Your use of the Site is at your
          sole risk.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Indemnification</h2>
        <p>
          You agree to indemnify, defend, and hold harmless Lotto Number Generator, its owners, operators, affiliates,
          and their respective officers, directors, employees, agents, and licensors from and against any and all
          claims, damages, obligations, losses, liabilities, costs, or expenses (including but not limited to
          reasonable attorney&apos;s fees) arising from: (a) your use of or access to the Site; (b) your violation of
          these Terms; (c) your violation of any third-party right, including any intellectual property, privacy, or
          proprietary right; or (d) any claim that your use of the Site caused damage to a third party. This
          indemnification obligation will survive the termination of these Terms and your use of the Site.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by applicable law, in no event shall Lotto Number Generator, its owners,
          operators, or affiliates be liable for any indirect, incidental, special, consequential, or punitive damages,
          including but not limited to loss of profits, data, use, goodwill, or other intangible losses, resulting from
          (a) your access to or use of or inability to access or use the Site; (b) any conduct or content of any third
          party on the Site; (c) any content obtained from the Site; or (d) unauthorized access, use, or alteration of
          your transmissions or content. Our total liability for all claims arising from or related to the Site shall
          not exceed the amount you have paid to us, if any, in the twelve months preceding the claim.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Modifications to Terms</h2>
        <p>
          We reserve the right to modify, amend, or replace these Terms at any time and at our sole discretion. If we
          make material changes, we will update the &quot;Last updated&quot; date at the bottom of this page. Your
          continued use of the Site after any modifications to these Terms constitutes your acceptance of the revised
          Terms. If you do not agree to the updated Terms, you should discontinue your use of the Site immediately. It
          is your responsibility to review these Terms periodically for changes.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the United States of America,
          without regard to its conflict of law provisions. Any disputes arising out of or relating to these Terms or
          your use of the Site shall be resolved in the federal or state courts located within the United States, and
          you consent to the personal jurisdiction of such courts. You agree that any cause of action arising out of or
          related to the Site must be commenced within one year after the cause of action accrues; otherwise, such cause
          of action is permanently barred.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Severability</h2>
        <p>
          If any provision of these Terms is held to be invalid, illegal, or unenforceable by a court of competent
          jurisdiction, the remaining provisions of these Terms shall remain in full force and effect. The invalid or
          unenforceable provision shall be modified to the minimum extent necessary to make it valid and enforceable
          while preserving the original intent of the provision to the greatest extent possible.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Entire Agreement</h2>
        <p>
          These Terms, together with our <Link to={lp('/privacy')}>Privacy Policy</Link>, constitute the entire agreement
          between you and Lotto Number Generator with respect to your use of the Site and supersede all prior or
          contemporaneous communications, proposals, and agreements, whether oral or written, between you and us
          regarding the Site. Any ambiguities in the interpretation of these Terms shall not be construed against the
          drafting party.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Contact Information</h2>
        <p>
          If you have any questions, concerns, or feedback regarding these Terms of Use, please contact us at{' '}
          <a href="mailto:contact@lotto-number-generator.com">contact@lotto-number-generator.com</a>. You can also
          reach us through our <Link to={lp('/contact')}>Contact</Link> page. We welcome your input and will do our best to
          respond to all inquiries in a timely manner.
        </p>

        <p style={{ marginTop: 24, color: 'var(--text-secondary)', fontSize: '0.95em' }}>
          <em>Last updated: October 22, 2026</em>
        </p>
    </article>
  );
}

export function TermsBodyKo({ lp }: { lp: Lp }) {
  return (
    <article className="policy-section">
<h1>이용약관</h1>
        <p>
          본 서비스는 <strong>개인적·비상업적 오락</strong> 목적으로만 이용할 수 있습니다. 본 사이트는 복권 발행 기관과 제휴하지 않으며,
          실제 복권은 각 관할 구역의 공식 판매처에서만 구매할 수 있습니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>도박·베팅 서비스가 아님</h2>
        <p>
          본 웹사이트는 <strong>금전을 걸거나 당첨금을 지급하는 도박, 베팅, 카지노, 스포츠북 등을 운영하지 않습니다.</strong> 제공하는 것은{' '}
          무료 <strong>소프트웨어 기능</strong>(난수 생성)입니다. 본 도구 사용 자체가 복권에 자동 응모되거나 베팅이
          성립하지는 않습니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>투자·복권 조언 아님</h2>
        <p>
          사이트의 어떤 내용도 투자·세무·법률·재무 자문이 아니며, 당첨 확률을 높여 주지 않습니다. 관련 법령을 준수하는 범위에서 오락 목적으로만
          이용하세요.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>합법·정직한 이용</h2>
        <p>
          사기, 기만, 권리 침해, 불법 목적 등으로 본 사이트를 이용해서는 안 됩니다. 도구의 기능을 허위로 과장하거나 결과를 보장하는 것처럼
          표시하지 마세요.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>보증의 부인</h2>
        <p>본 도구는 &quot;있는 그대로&quot; 제공되며 어떠한 보증도 하지 않습니다. 생성 번호는 난수입니다.</p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>책임의 제한</h2>
        <p>생성된 번호 또는 본 웹사이트 이용으로 발생한 손해에 대해 당사는 책임지지 않습니다.</p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>지적재산권</h2>
        <p>
          본 사이트에 게시된 모든 콘텐츠, 소스 코드, 디자인, 그래픽, 로고, 아이콘, 텍스트 및 기타 자료는 당사 또는 해당 라이선스
          제공자의 지적재산입니다. 이용자는 본 사이트의 콘텐츠를 개인적·비상업적 용도로만 이용할 수 있으며, 사전 서면 동의 없이
          콘텐츠를 복제, 배포, 수정, 전시, 판매하거나 파생 저작물을 작성할 수 없습니다. 본 사이트에서 사용된 제3자 상표 및 로고는
          해당 소유자의 자산이며, 이들의 사용이 해당 소유자의 보증이나 후원을 의미하지 않습니다. 오픈소스 라이브러리가 사용된 경우
          해당 라이브러리의 라이선스 조건이 적용됩니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>면책</h2>
        <p>
          이용자는 본 사이트 또는 서비스를 이용하거나, 본 약관을 위반하거나, 제3자의 권리를 침해함으로써 발생하는 모든 청구, 손해,
          비용, 책임 및 경비(합리적인 변호사 비용 포함)로부터 당사, 당사의 임직원, 대리인 및 제휴사를 면책하고 방어하는 데 동의합니다.
          이 면책 조항은 본 약관의 종료 후에도 유효하게 존속합니다. 이용자가 본 사이트에서 생성된 번호를 사용하여 복권을 구매하고
          결과적으로 손실이 발생한 경우에도 당사는 어떠한 책임도 부담하지 않습니다. 복권 구매는 전적으로 이용자 본인의 판단과
          책임 하에 이루어져야 합니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>약관 변경</h2>
        <p>
          당사는 본 이용약관을 수시로 변경할 수 있습니다. 약관이 변경되는 경우 이 페이지에 개정된 약관을 게시하며, 페이지 하단의 &quot;최종
          업데이트&quot; 날짜가 수정됩니다. 변경된 약관은 게시된 시점부터 효력이 발생하며, 변경 후에도 본 사이트를 계속 이용하면 개정된
          약관에 동의한 것으로 간주합니다. 중요한 변경 사항의 경우 사이트 내 공지를 통해 이용자에게 별도로 안내할 수 있습니다.
          이용자는 정기적으로 본 페이지를 방문하여 최신 약관을 확인하시기 바랍니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>준거법</h2>
        <p>
          본 이용약관의 해석 및 적용은 미합중국 법률 및/또는 대한민국 법률에 따르며, 이용자의 거주지 및 이용 상황에 따라 해당되는
          법률이 적용됩니다. 본 약관과 관련하여 분쟁이 발생할 경우, 양 당사자는 먼저 우호적인 협의를 통해 해결하도록 노력하며,
          협의가 이루어지지 않을 경우 관할 법원에 소를 제기할 수 있습니다. 본 약관의 어떠한 조항도 이용자가 관련 법령에 따라
          보유하는 법적 권리를 배제하거나 제한하지 않습니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>분리 가능성</h2>
        <p>
          본 약관의 일부 조항이 관할 법원에 의해 무효, 위법 또는 집행 불가능한 것으로 판정되더라도, 해당 조항은 허용되는 최대
          범위 내에서 효력을 유지하며, 나머지 조항은 완전한 효력을 가지고 존속합니다. 무효로 판정된 조항은 원래 의도에 가장
          부합하는 유효한 조항으로 대체되는 것으로 간주됩니다. 어떤 조항의 무효가 본 약관 전체의 무효를 의미하지는 않습니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>연락처</h2>
        <p>
          본 이용약관에 관한 문의 사항이 있으시면 아래 이메일 주소 또는 <Link to={lp('/contact')}>연락처</Link> 페이지를 통해
          연락해 주시기 바랍니다.
        </p>
        <p>
          이메일: <a href="mailto:contact@lotto-number-generator.com">contact@lotto-number-generator.com</a>
        </p>

        <p style={{ marginTop: 24, fontSize: '0.95em', color: 'var(--text-secondary)' }}>
          최종 업데이트: 2026년 10월 22일
        </p>
    </article>
  );
}

export function PrivacyBodyEn({ lp }: { lp: Lp }) {
  return (
    <article className="policy-section">
<h1>Privacy Policy</h1>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Introduction</h2>
        <p>
          This Privacy Policy explains how Lotto Number Generator (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;)
          collects, uses, and protects information when you visit and use our website at lotto-number-generator.com
          (the &quot;Site&quot;). By accessing or using the Site, you agree to the practices described in this policy.
          This policy applies to all visitors, users, and anyone else who accesses the Site. We encourage you to read this Privacy Policy carefully so that
          you understand how your information is handled. If you do not agree with the terms of this policy, please do
          not access or use the Site.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Google advertising partners</h2>
        <p>
          When ads are shown on our Site, Google and other third-party vendors may use cookies or similar technologies
          to serve ads based on your prior visits to this or other websites. You can learn how Google uses information
          from sites or apps that use its services here:{' '}
          <a href="https://www.google.com/policies/privacy/partners/" rel="noopener noreferrer">
            How Google uses data when you use our partners&apos; sites or apps
          </a>
          . You can opt out of personalized advertising from Google by visiting{' '}
          <a href="https://www.google.com/settings/ads" rel="noopener noreferrer">Google Ads Settings</a>.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Information We Collect</h2>
        <p>
          We do not directly collect personally identifiable information (PII) such as your name, email address, or
          phone number when you simply browse the Site. However, we do use third-party analytics tools that
          automatically gather certain anonymized or pseudonymized usage data to help us understand how visitors
          interact with our Site. The types of information that may be collected through these analytics services
          include:
        </p>
        <ul style={{ margin: '8px 0 0 20px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
          <li><strong>Pages visited</strong> — which pages you view, in what order, and how long you spend on each page.</li>
          <li><strong>Time on site</strong> — the total duration of your browsing session and engagement metrics.</li>
          <li><strong>Device type</strong> — whether you are using a desktop computer, tablet, or mobile phone, along with screen resolution and operating system information.</li>
          <li><strong>IP address</strong> — your Internet Protocol address, which may be used to approximate your geographic location at the country or city level. IP addresses are typically anonymized or truncated before storage by our analytics providers.</li>
          <li><strong>Browser information</strong> — the type and version of web browser you use, as well as your preferred language settings.</li>
          <li><strong>Referral source</strong> — how you arrived at our Site, such as through a search engine, direct link, or social media platform.</li>
        </ul>
        <p>
          We do not require you to create an account or provide any personal details to use the free features of our
          lottery number generator. If you choose to contact us via email, we will receive the information you
          voluntarily provide in that communication.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>How We Use Your Information</h2>
        <p>
          The anonymized data collected through analytics tools is used for the following purposes:
        </p>
        <ul style={{ margin: '8px 0 0 20px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
          <li><strong>Improve our service</strong> — we analyze usage patterns to identify areas of the Site that can be enhanced, optimized, or redesigned for a better user experience.</li>
          <li><strong>Understand usage patterns</strong> — aggregated data helps us see which features are most popular, which lottery games users prefer, and how visitors navigate through the Site.</li>
          <li><strong>Serve relevant advertisements</strong> — we use advertising networks that may display ads based on your browsing behavior. This helps us keep the core features of the Site free for all users.</li>
          <li><strong>Monitor site performance</strong> — usage data helps us detect technical issues, measure page load times, and ensure the Site runs smoothly across different devices and browsers.</li>
        </ul>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Third-Party Services</h2>
        <p>
          We rely on several trusted third-party services to operate the Site. Each of these services may collect and
          process data according to their own privacy policies. We encourage you to review their policies for full
          details:
        </p>
        <ul style={{ margin: '8px 0 0 20px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
          <li>
            <strong>Google Analytics (GA4)</strong> — we use Google Analytics 4 to collect and analyze website traffic
            data. GA4 uses cookies and collects data such as page views, session duration, and user demographics in
            anonymized form. Google may also use this data to contextualize and personalize ads within its own
            advertising network. You can learn more at{' '}
            <a href="https://policies.google.com/privacy" rel="noopener noreferrer">Google&apos;s Privacy Policy</a>.
          </li>
          <li>
            <strong>Microsoft Clarity</strong> — we use Microsoft Clarity to capture session recordings and heatmaps
            that show how users interact with the Site. Clarity records mouse movements, clicks, and scrolling behavior
            to help us understand usability patterns. Microsoft Clarity does not collect passwords or sensitive form
            data. Learn more at{' '}
            <a href="https://privacy.microsoft.com/privacystatement" rel="noopener noreferrer">Microsoft&apos;s Privacy Statement</a>.
          </li>
          <li>
            <strong>Google AdSense</strong> — we display advertisements through Google AdSense, which may serve
            personalized or non-personalized ads depending on your consent preferences and geographic location. Personalized
            ads use cookies and device identifiers to show you ads based on your browsing history and interests.
            Non-personalized ads are based on the content of the page you are viewing rather than your personal profile.
            You can manage your ad preferences at{' '}
            <a href="https://www.google.com/settings/ads" rel="noopener noreferrer">Google Ads Settings</a>.
          </li>
        </ul>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Cookies and Tracking Technologies</h2>
        <p>
          Cookies are small text files that are placed on your device by websites you visit. They are widely used to
          make websites work more efficiently and to provide reporting information to site owners. Our Site uses both
          first-party and third-party cookies:
        </p>
        <ul style={{ margin: '8px 0 0 20px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
          <li><strong>First-party cookies</strong> are set directly by our Site and are used to remember your preferences, such as your selected lottery game mode or language setting.</li>
          <li><strong>Third-party cookies</strong> are set by our analytics and advertising partners (Google Analytics, Microsoft Clarity, Google AdSense) and are used to track your browsing activity across different websites for analytics and advertising purposes.</li>
        </ul>
        <p>
          You can manage or delete cookies through your browser settings. Most browsers allow you to block all cookies,
          accept only first-party cookies, or be notified when a cookie is set. Please note that disabling cookies may
          affect the functionality of certain features on the Site. To opt out of Google Analytics tracking specifically,
          you can install the{' '}
          <a href="https://tools.google.com/dlpage/gaoptout" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a>.
          To opt out of personalized advertising, visit{' '}
          <a href="https://www.google.com/settings/ads" rel="noopener noreferrer">Google Ads Settings</a>{' '}
          or the{' '}
          <a href="https://optout.networkadvertising.org/" rel="noopener noreferrer">Network Advertising Initiative opt-out page</a>.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Data Retention</h2>
        <p>
          Analytics data collected through Google Analytics and Microsoft Clarity is retained according to the default
          retention settings configured by those services. Google Analytics data retention is set to the standard
          period defined by Google (typically 14 months for user-level data, though aggregated reports remain accessible
          indefinitely). Microsoft Clarity retains session recording data for up to 30 days by default. We do not store
          personal data on our own servers beyond what is necessary for the operation of the Site.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Children&apos;s Privacy</h2>
        <p>
          Our Site is not directed at children under the age of 13. We comply with the Children&apos;s Online Privacy
          Protection Act (COPPA) and do not knowingly collect personal information from children under 13 years of age.
          If we become aware that a child under 13 has provided us with personal information, we will take steps to
          delete that information as promptly as possible. If you are a parent or guardian and believe your child has
          provided personal information to us, please contact us at the email address listed below so that we can take
          appropriate action.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Your Rights</h2>
        <p>
          Depending on your location, you may have certain rights regarding your personal data. These rights may include:
        </p>
        <ul style={{ margin: '8px 0 0 20px', lineHeight: 1.8, color: 'var(--text-secondary)' }}>
          <li><strong>Opt out of personalized advertising</strong> — you can disable personalized ads through your Google Ads Settings or by adjusting cookie preferences in your browser.</li>
          <li><strong>Cookie controls</strong> — you have the right to accept or reject non-essential cookies through your browser settings at any time.</li>
          <li><strong>Data deletion requests</strong> — you may request that we delete any personal data we hold about you by contacting us via email. Since we do not directly collect PII through the Site, most deletion requests would need to be directed to the relevant third-party service providers (Google, Microsoft).</li>
          <li><strong>Access and portability</strong> — where applicable under laws such as the GDPR or CCPA, you may have the right to request access to the data collected about you or to receive it in a portable format.</li>
        </ul>
        <p>
          To exercise any of these rights, please reach out to us using the contact information provided at the bottom
          of this page.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>International Users</h2>
        <p>
          Our Site is available to users around the world. If you access the Site from outside the United States, please
          be aware that your information may be transferred to, stored, and processed in the United States, where our
          servers and third-party service providers are located. By using the Site, you consent to the transfer of your
          information to the United States and acknowledge that data protection laws in the United States may differ from
          those in your country of residence. We take reasonable steps to ensure that your data is treated securely and
          in accordance with this Privacy Policy regardless of where it is processed.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our practices, technologies, legal
          requirements, or other factors. When we make changes, we will revise the &quot;Last updated&quot; date at the
          bottom of this page. We encourage you to review this Privacy Policy periodically to stay informed about how
          we are protecting your information. Your continued use of the Site after any changes to this policy
          constitutes your acceptance of the updated terms.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Contact Us</h2>
        <p>
          If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please
          contact us at{' '}
          <a href="mailto:contact@lotto-number-generator.com">contact@lotto-number-generator.com</a>. You can also
          reach us through our <Link to={lp('/contact')}>Contact</Link> page. We will make every effort to respond to your
          inquiry in a timely manner.
        </p>

        <p style={{ marginTop: 24, color: 'var(--text-secondary)', fontSize: '0.95em' }}>
          <em>Last updated: October 22, 2026</em>
        </p>
    </article>
  );
}

export function PrivacyBodyKo({ lp }: { lp: Lp }) {
  return (
    <article className="policy-section">
<h1>개인정보처리방침</h1>
        <p>
          본 개인정보처리방침은 로또 번호 생성기 웹사이트(이하 &quot;본 사이트&quot;)가 이용자의 정보를 어떻게 수집, 이용, 보호하는지
          설명합니다. 본 사이트를 이용함으로써 이 방침에 동의한 것으로 간주합니다. 본 사이트는 Google Analytics와 Microsoft Clarity를
          통해 익명의 사용 데이터를 수집할 수 있습니다. 개인정보를 판매하지 않으며, Google AdSense를 통해 광고가 표시될 수 있습니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>Google 광고 및 제휴 사이트</h2>
        <p>
          본 사이트에 광고가 표시될 때 Google 및 기타 제3자는 쿠키 또는 유사 기술을 사용하여 이용자의 이전 방문 기록 등에 기반해 광고를
          게재할 수 있습니다. Google이 파트너 사이트·앱에서 정보를 어떻게 사용하는지는{' '}
          <a href="https://www.google.com/policies/privacy/partners/" rel="noopener noreferrer">
            Google 파트너 사이트 또는 앱을 사용할 때 Google이 데이터를 사용하는 방법
          </a>
          에서 확인할 수 있습니다. 맞춤 광고는{' '}
          <a href="https://www.google.com/settings/ads" rel="noopener noreferrer">Google 광고 설정</a>에서 끌 수 있습니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>수집하는 정보</h2>
        <p>
          본 사이트는 이용자에게 더 나은 서비스를 제공하기 위해 다음과 같은 정보를 자동으로 수집할 수 있습니다. 첫째, 분석 데이터로서
          페이지 조회수, 방문 시간, 세션 지속 시간, 유입 경로(참조 URL) 등이 수집됩니다. 둘째, 쿠키 및 유사 기술을 통해 사이트 기능
          유지, 이용자 선호 설정 저장, 광고 표시 최적화 등을 위한 소량의 텍스트 파일이 이용자의 브라우저에 저장될 수 있습니다. 셋째,
          기기 정보로서 브라우저 유형 및 버전, 운영 체제, 화면 해상도, 언어 설정 등 기술적 정보가 수집될 수 있습니다. 넷째, IP 주소가
          분석 서비스에 의해 수집될 수 있으나, 이는 익명화 처리되거나 집계 형태로만 사용됩니다. 본 사이트는 이름, 이메일 주소, 전화번호
          등 직접적인 개인 식별 정보를 별도로 요구하지 않습니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>정보의 이용 목적</h2>
        <p>
          수집된 정보는 다음과 같은 목적으로 이용됩니다. 첫째, 서비스 개선을 위해 이용자가 사이트를 어떻게 이용하는지 분석하고, 사용성과
          기능을 개선하는 데 활용합니다. 둘째, 분석 및 통계 목적으로 방문자 통계, 인기 페이지, 이용 패턴 등을 파악하여 사이트 운영
          전략을 수립합니다. 셋째, 광고 표시를 위해 Google AdSense를 통한 맞춤형 또는 비맞춤형 광고를 제공합니다. 이 과정에서 쿠키가
          사용될 수 있으며, 이용자는 광고 설정을 통해 맞춤 광고를 비활성화할 수 있습니다. 본 사이트는 수집된 정보를 제3자에게 판매하거나
          이전하지 않으며, 오직 위에 명시된 목적 범위 내에서만 이용합니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>제3자 서비스</h2>
        <p>
          본 사이트는 다음과 같은 제3자 서비스를 이용하며, 각 서비스는 자체 개인정보처리방침에 따라 정보를 수집·처리합니다.
        </p>
        <ul>
          <li>
            <strong>Google Analytics</strong> — 웹사이트 트래픽과 이용자 행동을 분석하기 위해 사용됩니다. 페이지 조회, 세션, 이벤트 등의
            데이터를 수집하며, IP 주소는 익명화 처리될 수 있습니다.
          </li>
          <li>
            <strong>Microsoft Clarity</strong> — 사이트 사용성을 개선하기 위해 클릭 패턴, 스크롤 깊이, 세션 녹화 등의 행동 데이터를
            수집합니다. 개인 식별 정보는 수집하지 않습니다.
          </li>
          <li>
            <strong>Google AdSense</strong> — 광고 표시를 위해 쿠키를 사용하며, 이용자의 관심사에 기반한 맞춤형 광고를 제공할 수 있습니다.
            이용자는 Google의 광고 설정 페이지에서 맞춤 광고를 비활성화할 수 있습니다.
          </li>
        </ul>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>쿠키 및 추적 기술</h2>
        <p>
          쿠키란 웹사이트가 이용자의 브라우저에 저장하는 소량의 텍스트 파일입니다. 본 사이트는 필수 쿠키(사이트 기능 유지),
          분석 쿠키(Google Analytics, Microsoft Clarity), 광고 쿠키(Google AdSense)를 사용합니다. 이용자는 브라우저 설정에서
          쿠키를 관리하거나 삭제할 수 있습니다. 대부분의 최신 브라우저는 쿠키 차단, 삭제, 만료 시 알림 기능을 제공합니다. 다만,
          쿠키를 비활성화하면 사이트의 일부 기능이 정상적으로 작동하지 않을 수 있습니다. 또한 &quot;Do Not Track&quot; 신호에 대한
          업계 표준이 아직 확립되지 않았으므로, 현재 본 사이트는 해당 신호에 별도로 대응하지 않습니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>아동의 개인정보</h2>
        <p>
          본 사이트는 만 13세 미만의 아동을 대상으로 하지 않으며, 의도적으로 아동의 개인정보를 수집하지 않습니다. 만약 만 13세 미만의
          아동이 본 사이트에 개인정보를 제공한 사실을 알게 된 경우, 해당 정보를 즉시 삭제하기 위해 합리적인 조치를 취하겠습니다.
          보호자께서 자녀의 개인정보가 수집된 것으로 의심되는 경우 아래 연락처로 문의해 주시기 바랍니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>이용자의 권리</h2>
        <p>
          이용자는 본 사이트에서 수집하는 데이터에 대해 다음과 같은 권리를 행사할 수 있습니다. 첫째, 분석 추적을 거부(opt-out)할 수
          있습니다. Google Analytics 옵트아웃 브라우저 애드온을 설치하면 Google Analytics에 의한 데이터 수집을 중단할 수 있습니다.
          둘째, 브라우저의 쿠키 설정을 통해 쿠키를 삭제하거나 차단할 수 있습니다. 셋째, Google의 광고 설정 페이지에서 맞춤형 광고를
          비활성화할 수 있습니다. 관련 법령에 따라 개인정보의 열람, 정정, 삭제를 요청할 권리가 있으며, 이러한 요청은 아래 연락처로
          보내주시기 바랍니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>정책 변경</h2>
        <p>
          본 개인정보처리방침은 법률 변경, 서비스 변경, 기술적 필요 등의 이유로 수시로 업데이트될 수 있습니다. 변경 사항이 있을 경우
          이 페이지를 통해 공지하며, 중요한 변경 사항의 경우 사이트 내 별도 안내를 제공할 수 있습니다. 이용자는 정기적으로 본 페이지를
          확인하여 최신 방침을 숙지하시기 바랍니다.
        </p>

        <h2 style={{ fontSize: '1.1em', marginTop: 16, marginBottom: 8 }}>연락처</h2>
        <p>
          본 개인정보처리방침에 대한 문의 사항이 있으시면 아래 이메일 주소 또는 <Link to={lp('/contact')}>연락처</Link> 페이지를 통해
          연락해 주시기 바랍니다.
        </p>
        <p>
          이메일: <a href="mailto:contact@lotto-number-generator.com">contact@lotto-number-generator.com</a>
        </p>

        <p style={{ marginTop: 24, fontSize: '0.95em', color: 'var(--text-secondary)' }}>
          최종 업데이트: 2026년 10월 22일
        </p>
    </article>
  );
}
